export default __webpack_public_path__ + "img/mic.254f89aa.svg";